import type { ReactElement } from "react";

import type { TIconProps } from "../types";

export const MicrosoftExchangeServer = (props: TIconProps): ReactElement => (
  <svg
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 25 24"
    {...props}
  >
    <path
      id="microsoftexchangeserver_Layer_9_"
      fill="hsl(from hsl(206 100% 42%) h s 59%)"
      d="M23.4,0.9h-5.5c-0.2,0-0.4,0-0.6,0.1c-0.2,0.1-0.4,0.2-0.5,0.4L3.7,14.8
	c-0.1,0.2-0.3,0.3-0.3,0.5s-0.1,0.4-0.1,0.6v5.7c0,0.2,0,0.4,0.1,0.6c0.1,0.2,0.2,0.4,0.3,0.5C3.8,22.9,4,23,4.2,23.1
	c0.2,0.1,0.4,0.1,0.6,0.1h5.5c0.2,0,0.4,0,0.6-0.1c0.2-0.1,0.4-0.2,0.5-0.4L24.5,9.3C24.8,9,25,8.6,25,8.2V2.5c0-0.2,0-0.4-0.1-0.6
	c-0.1-0.2-0.2-0.4-0.3-0.5C24.4,1.2,24.2,1.1,24,1C23.8,0.9,23.6,0.9,23.4,0.9z"
    />
    <path
      id="microsoftexchangeserver_Layer_8_"
      fill="hsl(from hsl(206 100% 42%) h s 42%)"
      d="M23.4,23.2h-5.5c-0.4,0-0.8-0.2-1.1-0.5L14.1,20V15c0-0.8,0.3-1.5,0.8-2.1c0.5-0.5,1.3-0.9,2-0.9
	h5l2.6,2.7c0.3,0.3,0.5,0.7,0.5,1.1v5.7c0,0.4-0.2,0.8-0.5,1.1C24.2,23.1,23.8,23.2,23.4,23.2z"
    />
    <path
      id="microsoftexchangeserver_Layer_7_"
      fill="hsl(from hsl(206 100% 42%) h s 74%)"
      d="M4.8,0.9h5.5c0.4,0,0.8,0.2,1.1,0.5l2.6,2.7v5.1c0,0.8-0.3,1.5-0.8,2.1c-0.5,0.5-1.3,0.9-2,0.9
	h-5L3.7,9.3C3.4,9,3.2,8.6,3.2,8.2V2.5c0-0.4,0.2-0.8,0.5-1.1C4,1.1,4.4,0.9,4.8,0.9z"
    />
    <path
      id="microsoftexchangeserver_Layer_6_"
      opacity="0.2"
      d="M13.2,6.6v12.3c0,0.1,0,0.1,0,0.2c0,0.3-0.2,0.5-0.4,0.6c-0.2,0.2-0.4,0.3-0.7,0.3H3.2V5.5h8.9
	c0.1,0,0.3,0,0.4,0.1c0.1,0.1,0.2,0.1,0.3,0.2C13,6,13.1,6.1,13.1,6.2C13.2,6.4,13.2,6.5,13.2,6.6z"
    />
    <path
      id="microsoftexchangeserver_Layer_5_"
      opacity="0.1"
      d="M13.6,6.6V18c0,0.4-0.2,0.8-0.4,1.1c-0.3,0.3-0.7,0.5-1.1,0.5H3.2V5.1h8.9c0.4,0,0.8,0.2,1.1,0.5
	C13.5,5.8,13.6,6.2,13.6,6.6z"
    />
    <path
      id="microsoftexchangeserver_Layer_4_"
      opacity="0.2"
      d="M13.2,6.6V18c0,0.1,0,0.3-0.1,0.4c-0.1,0.1-0.1,0.3-0.2,0.4c-0.1,0.1-0.2,0.2-0.3,0.2
	C12.4,19,12.3,19,12.1,19H3.2V5.5h8.9c0.1,0,0.3,0,0.4,0.1c0.1,0.1,0.2,0.1,0.3,0.2C13,6,13.1,6.1,13.1,6.2
	C13.2,6.4,13.2,6.5,13.2,6.6z"
    />
    <path
      id="microsoftexchangeserver_Layer_3_"
      opacity="0.1"
      d="M12.7,6.6V18c0,0.1,0,0.3-0.1,0.4c-0.1,0.1-0.1,0.3-0.2,0.4c-0.1,0.1-0.2,0.2-0.3,0.2
	C12,19,11.8,19,11.7,19H3.2V5.5h8.5c0.1,0,0.3,0,0.4,0.1c0.1,0.1,0.2,0.1,0.3,0.2c0.1,0.1,0.2,0.2,0.2,0.4
	C12.7,6.4,12.7,6.5,12.7,6.6z"
    />
    <path
      id="microsoftexchangeserver_Layer_2_"
      fill="hsl(from hsl(206 100% 42%) h s 42%)"
      d="M11.7,5.5H1.1C0.5,5.5,0,6,0,6.6v10.9c0,0.6,0.5,1.1,1.1,1.1h10.6c0.6,0,1.1-0.5,1.1-1.1V6.6
	C12.7,6,12.3,5.5,11.7,5.5z"
    />
    <path
      id="microsoftexchangeserver_Layer_1_"
      fill="hsl(from hsl(206 100% 42%) h s 100%)"
      d="M8.5,9.7h-3v1.8h2.8v1.1H5.5v1.9h3.1v1.1H4.1V8.5h4.3V9.7z"
    />
  </svg>
);
